<app-side-top-bar [navigationItems]="navigationItems">
  <main>
    <div
      [ngClass]="
        isPatientActive ? 'patient-name' : 'patient-name name-not-active'
      "
    >
      <h2>{{ patientNameAndSurname }}</h2>
    </div>
    <section class="life-line-page">
      <header class="header">
        <div class="sections">
          <div
            class="{{ isLifeLineSelected }}"
            (click)="displayLifeLineSection()"
          >
            <h2>{{ labelService.getLabel("life_line") }}</h2>
          </div>
          <div
            class="{{ isSignificantEventSelected }}"
            (click)="displaySignificantEventSection()"
          >
            <h2>{{ labelService.getLabel("significant_events") }}</h2>
          </div>
        </div>
        @if (isSignificantEventSelected === "selected") {
          <div class="header-buttons">
            <app-button
              [icon]="'add'"
              (click)="toggleNewSignificantEventPanel()"
            ></app-button>
            @if (lifeLineEvents.length > 0) {
              <app-button
                [icon]="editOrDeleteString"
                [size]="'icon_small'"
                (click)="onModifyButtonClick()"
              ></app-button>
            }
          </div>
        }
      </header>

      @if (isLifeLineSelected === "selected") {
        <section class="lifeline-section">
          <app-lifeline-section
            [patientNameAndSurname]="patientNameAndSurname"
            [significantEvents]="lifeLineEvents"
          ></app-lifeline-section>
        </section>
      }

      @if (isSignificantEventSelected === "selected") {
        <section class="significant-events-section">
          @if (!isLoadingEvents) {
            <app-significant-events-section
              class="significant-events-section"
              [significantEvents]="lifeLineEvents"
              [hasModifyButtonBeenClicked]="hasModifyButtonBeenClicked"
              [patientId]="patientId"
              (refreshEventList)="fetchSignificantEvents()"
            ></app-significant-events-section>
          }
          @if (isLoadingEvents) {
            <app-loader
              [size]="'big'"
              style="display: flex; justify-content: center; margin-top: 3rem"
            ></app-loader>
          }
        </section>
      }

      @if (showNewSignificantEventPanel) {
        <app-panel-lifeline-event
          [panelTitle]="panelTitle"
          [eventTitle]="eventTitle"
          [eventStartDay]="eventStartDay"
          [eventStartMonth]="eventStartMonth"
          [eventStartYear]="eventStartYear"
          [eventEndDay]="eventEndDay"
          [eventEndMonth]="eventEndMonth"
          [eventEndYear]="eventEndYear"
          (cancel)="toggleNewSignificantEventPanel()"
          (confirm)="addNewSignificantEvent($event)"
        ></app-panel-lifeline-event>
      }
    </section>
  </main>
</app-side-top-bar>
